const STATIC_PAGE_PURIFY = {
  ADD_TAGS: ["style"],
};

export const sanitizeStaticPage = async (content: string) => {
  const { default: domPurify } = await import("isomorphic-dompurify");
  return domPurify.sanitize(content, STATIC_PAGE_PURIFY);
};
